// Pequeño wrapper de fetch que adjunta X-TOKEN y redirige al login en 401
export type FetchWithAuthOptions = RequestInit & {
  autoAttachToken?: boolean
}

const getTokenFromStorage = (): string | null => {
  try {
    return localStorage.getItem('X-TOKEN')
  } catch {
    return null
  }
}

const removeTokenFromStorage = () => {
  try {
    localStorage.removeItem('X-TOKEN')
  } catch {}
}

const saveTokenToStorage = (token: string) => {
  try {
    localStorage.setItem('X-TOKEN', token)
  } catch {}
}

export async function fetchWithAuth(input: RequestInfo | URL, init: FetchWithAuthOptions = {}): Promise<Response> {
  const {autoAttachToken = true, headers, ...rest} = init

  const composedHeaders = new Headers(headers || {})

  // Adjunta JSON por defecto si hay body
  if (rest.body && !composedHeaders.has('Content-Type')) {
    composedHeaders.set('Content-Type', 'application/json')
  }

  // Adjuntar X-TOKEN automáticamente
  if (autoAttachToken && !composedHeaders.has('X-TOKEN')) {
    const token = getTokenFromStorage()
    if (token) composedHeaders.set('X-TOKEN', token)
  }

  const response = await fetch(input, {
    ...rest,
    headers: composedHeaders,
  })

  if (response.status === 401) {
    removeTokenFromStorage()
    // Redirigir al login. Usamos location para evitar depender del router aquí.
    if (typeof window !== 'undefined') {
      window.location.href = '/auth/login'
    }
  } else if (response.ok) {
    // Si la respuesta es exitosa, intentar extraer y guardar el X-TOKEN del header
    try {
      const newToken = response.headers.get('X-TOKEN') || response.headers.get('x-token')
      if (newToken && typeof newToken === 'string') {
        saveTokenToStorage(newToken)
      }
    } catch {
      // Si hay algún error al leer el header, continuar normalmente
    }
  }

  return response
}

export default fetchWithAuth


